import React from 'react';
import { ChevronRight } from 'lucide-react';
import { formatRelativeTime } from 'shared/utils/dateUtils';
import { DEFAULT_GROUP_COLUMNS } from 'features/activity/config/groupColumns';
import {
  TABLE_STYLES,
  tableRowClass,
  tableDataCellClass,
} from 'features/activity/styles/dataTableStyles';

const GroupRow = ({ group, onRowClick, columns, styles: stylesProp }) => {
  const styles = stylesProp || TABLE_STYLES;

  const getCellValue = (columnKey) => {
    // Fixed columns
    switch (columnKey) {
      case 'group_id': {
        const raw = group.groupId || '';
        if (!raw) return '—';
        const s = String(raw);
        if (s.length <= 20) return s;
        return `${s.slice(0, 10)}...${s.slice(-8)}`;
      }
      case 'member_count':
        return group.memberCount != null ? group.memberCount.toLocaleString() : '0';
      case 'last_updated_at':
        if (!group.updatedAt) return 'N/A';
        return formatRelativeTime(new Date(group.updatedAt));
      case 'created_at':
        if (!group.createdAt) return 'N/A';
        return formatRelativeTime(new Date(group.createdAt));
      default: {
        // Custom property column
        const val = group.customProperties?.[columnKey];
        if (val === null || val === undefined) return '—';
        if (Array.isArray(val)) return val.join(', ');
        if (typeof val === 'object') return JSON.stringify(val);
        return String(val);
      }
    }
  };

  const displayColumns =
    columns && columns.length > 0 ? columns : DEFAULT_GROUP_COLUMNS.order;

  return (
    <tr
      onClick={() => onRowClick && onRowClick(group)}
      className={tableRowClass}
    >
      {displayColumns.map((columnKey, idx) => {
        const value = getCellValue(columnKey);
        const isMissing = !value || value === '—' || value === 'N/A';
        const isIdentifier = idx === 0;
        const cellClass = isMissing
          ? 'text-[12px] text-[color:var(--text-muted)]'
          : isIdentifier
            ? 'font-mono text-[11px] text-[color:var(--text-primary)]'
            : 'text-[12px]';
        const cellColor = !isMissing && !isIdentifier ? styles.textWarmSecondary || 'var(--text-secondary)' : undefined;
        return (
          <td key={columnKey} className={`${tableDataCellClass} whitespace-nowrap`}>
            <div className={cellClass} style={cellColor ? { color: cellColor } : undefined}>
              <span title={typeof value === 'string' ? value : ''}>{value || '—'}</span>
            </div>
          </td>
        );
      })}
      <td className={`${tableDataCellClass} w-8 text-right`}>
        <ChevronRight className="h-4 w-4 inline" style={{ color: styles.textSecondary }} />
      </td>
    </tr>
  );
};

export default GroupRow;
